import React from "react";
import { Stack } from "@mui/material";

import { DialogButton, HubHookFormWrapper } from "../../components";

import ContactsLocationFilter from "../../pages/Companies/ContactsLocationFilter";

const FinancialsBar = ({ disabled }) => (
  <HubHookFormWrapper onSubmit={() => {}} sx={{ width: "100%" }}>
    <Stack justifyContent="space-between" direction="row" width="100%">
      <Stack direction="row" gap="10px">
        <ContactsLocationFilter multiSelect={false} />
      </Stack>
      <Stack direction="row" gap="10px">
        <DialogButton
          name="financial-period"
          label="New Financial Period"
          variant="contained"
          size="xsmall"
          disabled={disabled}
        />
      </Stack>
    </Stack>
  </HubHookFormWrapper>
);

export default FinancialsBar;
